import { useRef, useState } from "react";
import QRCode from "react-qr-code";
import html2canvas from "html2canvas";
import styles from "./QrCodeModal.module.css";

export default function QrCodeModal({ onClose }) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const qrRef = useRef(null);

  function isValidUrl(value) {
    return value.startsWith("http://") || value.startsWith("https://");
  }

  function handleChange(e) {
    const value = e.target.value;
    setUrl(value);

    if (!value.trim()) {
      setError("");
      return;
    }

    if (!isValidUrl(value)) {
      setError("A URL deve começar com http:// ou https://");
    } else {
      setError("");
    }
  }

  async function handleDownload() {
    if (!qrRef.current) return;

    try {
      const canvas = await html2canvas(qrRef.current);
      canvas.toBlob((blob) => {
        if (!blob) return;
        const urlBlob = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlBlob;
        link.download = "qrcode.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(urlBlob);
      }, 'image/png');
    } catch (error) {
      console.error('Error generating PNG:', error);
    }
  }

  const showQRCode = url.trim() && !error;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
      >
        <header className={styles.header}>
          <h2 className={styles.title}>Gerar QR Code</h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Fechar modal"
          >
            ×
          </button>
        </header>

        <form
          className={styles.form}
          onSubmit={(e) => e.preventDefault()}
        >
          <label className={styles.label}>
            URL
            <input
              type="url"
              placeholder="https://exemplo.com"
              className={styles.input}
              value={url}
              onChange={handleChange}
              autoFocus
            />
          </label>

          {error && <div className={styles.error}>{error}</div>}
        </form>

        {showQRCode && (
          <div className={styles.qrWrap}>
            <div className={styles.qrCard}>
              <div className={styles.qrInner} ref={qrRef}>
                <QRCode value={url} size={256} />
              </div>

              <div className={styles.qrMeta}>
                <button
                  className={styles.downloadButton}
                  onClick={handleDownload}
                >
                  Baixar PNG
                </button>

                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.qrLink}
                >
                  Abrir URL
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
